import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getProfileAction } from "../../redux/actions/userProfileActions";

const useGetProfileData = () => {
  const { token } = useSelector((store) => store.userReducer);
  const dispatch = useDispatch();
  useEffect(() => {
    if (token) dispatch(getProfileAction());
  }, [token]);
};

export default useGetProfileData;
